import React from "react";

import styled from "styled-components";
import { scrollbars } from "theme/mixins";

const Body: React.FC<{ className?: string }> = ({ children, className }) => {
  return (
    <ModalBody className={className}>
      <Inner>{children}</Inner>
    </ModalBody>
  );
};

const ModalBody = styled.div`
  overflow-y: auto;
  line-height: 1.5;
  margin: 0 0.5rem 0.5rem 0;
  ${scrollbars()}
`;

const Inner = styled.div`
  margin: 1rem;
  padding: 0 1rem;
`;

export default Body;
